<app-spinner *ngIf="isLoading"></app-spinner>
<div class="processing" *ngIf="isLoading && !imageLoading">
  <h4>Procesando datos...</h4>
</div>
<div class="processing" *ngIf="isLoading && imageLoading">
  <h4>Procesando imágenes...</h4>
  <h5>Si son grandes, pueden tardar unos segundos...</h5>
</div>

<div class="edited" *ngIf="!isLoading && edited">
  <ngb-alert [type]="'success'" *ngIf="errorMessage">
    {{ errorMessage }}
  </ngb-alert>
  <h5 class="pt-5 pb-3">
    Volviendo automáticamente al listado en <strong>3 segundos</strong>...
  </h5>

  <div class="pt-5">
    <a (click)="onNavigate('this')" class="btn btn-lg btn-block btn-light">
      <i class="fa fa-pencil" aria-hidden="true"></i>&nbsp;&nbsp;Revisar el
      plato
    </a>
  </div>
</div>

<div class="card" *ngIf="!isLoading && !edited">
  <div class="card-header" *ngIf="mode === 'create'">Nuevo plato</div>
  <div class="card-header" *ngIf="mode === 'edit'">Editar plato</div>
  <div class="card-body">
    <form (submit)="onSubmit(platoForm)" #platoForm="ngForm">
      <ngb-alert [type]="'danger'" *ngIf="errorMessage">
        {{ errorMessage }}
      </ngb-alert>
      <div class="row">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <!--<p class="text-danger">* Campos obligatorios</p>-->

          <div class="mb-3">
            <label class="form-label">
              Fecha: <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <input
                class="form-control input-calendar"
                name="plato_date_full"
                [(ngModel)]="plato.plato_date_full"
                ngbDatepicker
                #d="ngbDatepicker"
                (click)="d.toggle()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary fa fa-calendar"
                  (click)="d.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">
              Horario: <span class="text-danger">*</span>
            </label>
            <select
              class="form-control"
              name="horarioID"
              [ngModel]="plato.horario_id"
              #horarioIDInput="ngModel"
              (change)="onPlatoChange(platoForm)"
            >
              <ng-container *ngFor="let horario of horarios">
                <ng-container *ngIf="plato.horario_id == horario.horario_id">
                  <option [value]="horario.horario_id" selected>
                    {{ horario.horario_description }}
                  </option>
                </ng-container>
                <ng-container *ngIf="plato.horario_id != horario.horario_id">
                  <option [value]="horario.horario_id">
                    {{ horario.horario_description }}
                  </option>
                </ng-container>
              </ng-container>
              <option value="other">Otro...</option>
            </select>
          </div>
          <div class="mb-3" *ngIf="platoForm.value.horarioID == 'other'">
            <input
              type="text"
              class="form-control"
              name="custom_horario"
              [ngModel]="plato.custom_horario"
              placeholder="Especificar horario..."
            />
          </div>

          <div class="mb-3">
            <label class="form-label">
              Descripción: <span class="text-danger">*</span>
            </label>
            <textarea
              class="form-control"
              rows="8"
              name="plato_description"
              [ngModel]="plato.plato_description"
              class="form-control"
              required
            ></textarea>
          </div>

          <div class="mb-3" *ngIf="plato.plato_date_full">
            <label class="form-label">
              URL amigable:
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                placement="top"
                ngbTooltip="Mejora el posicionamiento en buscadores. Debe ser única."
              ></i>
            </label>
            <input
              type="text"
              class="form-control"
              [value]="processURLSlug(platoForm.value.plato_description)"
              disabled
            />
          </div>

          <div class="mb-3">
            <label class="form-label">
              Dieta: <span class="text-danger">*</span>
            </label>
            <select
              class="form-control"
              name="dieta"
              name="dietaID"
              [ngModel]="plato.dieta_id"
              #dietaIDInput="ngModel"
              (change)="onPlatoChange(platoForm)"
            >
              <ng-container *ngFor="let dieta of dietas">
                <ng-container *ngIf="plato.dieta_id == dieta.dieta_id">
                  <option [value]="dieta.dieta_id" selected>
                    {{ dieta.dieta_description }}
                  </option>
                </ng-container>
                <ng-container *ngIf="plato.dieta_id != dieta.dieta_id">
                  <option [value]="dieta.dieta_id">
                    {{ dieta.dieta_description }}
                  </option>
                </ng-container>
              </ng-container>
              <option value="other">Otro...</option>
            </select>
          </div>
          <div class="mb-3" *ngIf="platoForm.value.dietaID == 'other'">
            <input
              type="text"
              class="form-control"
              name="custom_dieta"
              [ngModel]="plato.custom_dieta"
              placeholder="Especificar dieta..."
            />
          </div>

          <div class="mb-3">
            <label class="form-label">
              Es una evolución de:
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                placement="top"
                ngbTooltip="Si el plato ha sido elaborado partiendo de uno anterior"
              >
              </i>
              <small class="text-muted">&nbsp;&nbsp;(Opcional)</small>
            </label>

            <input
              *ngIf="plato.parent_text && !showEvolucionDe"
              type="text"
              class="form-control"
              style="margin-bottom: 0.5em"
              [value]="plato.parent_text"
              disabled
            />

            <a
              (click)="getPlatos()"
              class="btn btn-sm btn-block btn-light"
              *ngIf="!showEvolucionDe"
            >
              <i class="fa fa-pencil" aria-hidden="true"></i>&nbsp;&nbsp;Editar
            </a>

            <div class="row" *ngIf="showEvolucionDe">
              <div class="col-md-7 col-sm-12 col-xs-12">
                <input
                  *ngIf="platos && !platos.length"
                  type="text"
                  class="form-control"
                  [value]="'No hay resultados'"
                  disabled
                />
                <select
                  class="form-control"
                  name="parentID"
                  [ngModel]="plato.parent_id"
                  #platosSelectList="ngModel"
                  *ngIf="platos && platos.length"
                >
                  <option [value]="null" disabled selected>- Ninguno -</option>
                  <ng-container *ngFor="let item of platos">
                    <ng-container
                      *ngIf="parentIdFocus && item.plato_id == plato.parent_id"
                    >
                      <option [value]="item.plato_id" selected>
                        {{ item.plato_text }}
                      </option>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        parentIdFocus &&
                        item.plato_id != plato.parent_id &&
                        item.plato_id != plato.plato_id
                      "
                    >
                      <option [value]="item.plato_id">
                        {{ item.plato_text }}
                      </option>
                    </ng-container>
                    <!--<ng-container
                      *ngIf="parentIdFocus && item.plato_id == plato.parent_id"
                    >
                      <option [value]="item.plato_id" selected>
                        {{ item.plato_date.substr(0, 10) }}
                        ({{ item.horario_description }}):&nbsp;&nbsp;
                        {{ item.plato_description.substr(0, 40) }}...
                      </option>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        parentIdFocus &&
                        item.plato_id != plato.parent_id &&
                        item.plato_id != plato.plato_id
                      "
                    >
                      <option [value]="item.plato_id">
                        {{ item.plato_date.substr(0, 10) }}
                        ({{ item.horario_description }}):&nbsp;&nbsp;
                        {{ item.plato_description.substr(0, 40) }}...
                      </option>
                    </ng-container>-->
                  </ng-container>
                </select>
              </div>
              <div class="col-md-5 col-sm-12 col-xs-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"
                      ><i class="fa fa-search" aria-hidden="true"></i
                    ></span>
                  </div>

                  <input
                    class="form-control"
                    type="text"
                    (ngModelChange)="filterPlato($event)"
                    name="platosFilterText"
                    placeholder="Filtrar platos"
                    [(ngModel)]="platosFilterText"
                  />
                </div>
              </div>
            </div>
          </div>

          <label>
            Fotografías del plato:
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              placement="top"
              ngbTooltip="Se debe incluir al menos una imagen en formato JPG o PNG. Es posible pulsar y arrastrar para modificar el orden de visualización."
            >
            </i>
            &nbsp;<span class="text-danger">*</span>
          </label>

          <div dragula="images" [(dragulaModel)]="plato.images">
            <div *ngFor="let image of plato.images; let i = index">
              <div class="row ingrediente imagen">
                <div class="col-md-7 col-sm-12 col-xs-12">
                  <button
                    class="btn btn-light btn-image"
                    type="button"
                    (click)="imagePicker.click()"
                  >
                    <i class="fa fa-picture-o" aria-hidden="true"></i>&nbsp;
                    <span *ngIf="plato.images[i] && plato.images[i].preview"
                      >Reemplazar</span
                    ><span *ngIf="!plato.images[i] || !plato.images[i].preview"
                      >Seleccionar</span
                    >
                  </button>
                  <input
                    type="file"
                    accept="image/x-png,image/jpeg"
                    #imagePicker
                    (change)="onImagePicked($event, i)"
                    id="imagePicker_{{ i }}"
                  />
                  <div class="form-group">
                    <select
                      class="form-control"
                      name="image_tipoID_{{ i }}"
                      id="image_tipoID_{{ i }}"
                      [ngModel]="image.tipo_id"
                      #tipoIDInput
                      (change)="onImageTipoIDChanged(image, tipoIDInput)"
                    >
                      <ng-container *ngFor="let tipo of tiposImagenes">
                        <ng-container *ngIf="image.tipo_id == tipo.tipo_id">
                          <option [value]="tipo.tipo_id" selected>
                            {{ tipo.tipo_description }}
                          </option>
                        </ng-container>
                        <ng-container *ngIf="image.tipo_id != tipo.tipo_id">
                          <option [value]="tipo.tipo_id">
                            {{ tipo.tipo_description }}
                          </option>
                        </ng-container>
                      </ng-container>
                    </select>
                  </div>

                  <span class="btn btn-light" (click)="onDeleteImagen(i)"
                    ><i class="fa fa-trash-o"></i>
                    &nbsp;&nbsp;Eliminar
                  </span>
                </div>

                <div class="col-md-4 col-sm-12 col-xs-12 text-center">
                  <a
                    *ngIf="
                      plato &&
                      plato.images[i] &&
                      plato.images[i].preview &&
                      plato.images[i].preview.includes('http')
                    "
                    target="_blank"
                    href="{{ plato.images[i].preview }}"
                  >
                    <img
                      id="preview_{{ i }}"
                      src="{{
                        plato.images[i].preview.replace(
                          '/images/',
                          '/images/l-'
                        )
                      }}"
                      class="img-thumbnail"
                    />
                  </a>
                  <img
                    *ngIf="
                      plato &&
                      plato.images[i] &&
                      plato.images[i].preview &&
                      !plato.images[i].preview.includes('http')
                    "
                    src="{{ plato.images[i].preview }}"
                    class="img-thumbnail"
                  />

                  <!--<label class="btn btn-default file-input">
              Arrastrar o seleccionar <input type="file" hidden />
            </label>-->
                </div>

                <div class="col-md-1 col-sm-12 col-xs-12 text-center">
                  <i class="fa fa-sort" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
          <button
            class="btn btn-light btn-add"
            *ngIf="this.plato.images"
            [disabled]="!plato.images[this.plato.images.length - 1].preview"
            (click)="onAddImagen()"
          >
            <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otra imagen
          </button>
        </div>

        <div class="col-md-6 col-sm-6 col-xs-12 right-column">
          <div class="mb-3">
            <label>
              Estación: <span class="text-danger">*</span>
              <small class="text-muted">&nbsp;(Elegir una)</small>
            </label>
            <div class="image-selector">
              <div *ngFor="let estacion of estaciones" class="image-selector">
                <div
                  class="image-button"
                  (click)="onSelectEstacion(estacion.estacion_id)"
                  [className]="
                    estacion.estacion_id == plato.estacion_id
                      ? 'active'
                      : 'inactive'
                  "
                >
                  <span
                    class="image-bg"
                    [ngStyle]="{
                      'background-image':
                        'url(../../assets/img/plato/' +
                        estacion.estacion_image +
                        ')'
                    }"
                  >
                    <span class="image-text">{{
                      estacion.estacion_description
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label>
              Técnica de cocción: <span class="text-danger">*</span>
              <small class="text-muted">&nbsp;(Elegir una o varias)</small>
            </label>

            <div class="image-selector">
              <div
                *ngFor="let tecnica of tecnicasCoccion"
                class="image-selector"
              >
                <div
                  class="image-button"
                  (click)="onSelectTecnica(tecnica.tecnica_id)"
                  [className]="
                    isTecnicaSelected(tecnica.tecnica_id) >= 0
                      ? 'active'
                      : 'inactive'
                  "
                >
                  <span
                    class="image-bg"
                    [ngStyle]="{
                      'background-image':
                        'url(../../assets/img/plato/' +
                        tecnica.tecnica_image +
                        ')'
                    }"
                  >
                    <span class="image-text">{{
                      tecnica.tecnica_description
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <br />
            <div
              class="btn btn-success btn-block"
              id="getCoordinatesBtn"
              (click)="getCoordinates(null)"
            >
              <i class="fa fa-cog"></i>&nbsp;&nbsp;Extraer ubicación de las
              imágenes
            </div>
            <br />
            <div class="row">
              <div class="col-md-6">
                <label>Latitud GPS:</label>
                <input
                  type="text"
                  class="form-control"
                  name="latitud"
                  [ngModel]="plato.latitud"
                  placeholder="Especificar latitud..."
                />
              </div>
              <div class="col-md-6">
                <label>Longitud GPS:</label>
                <input
                  type="text"
                  class="form-control"
                  name="longitud"
                  [ngModel]="plato.longitud"
                  placeholder="Especificar longitud..."
                />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-6">
                <label>Localidad:</label>
                <input
                  type="text"
                  class="form-control"
                  name="ciudad"
                  [ngModel]="plato.ciudad"
                  placeholder="Especificar localidad..."
                />
              </div>
              <div class="col-md-6">
                <label>País:</label>
                <input
                  type="text"
                  class="form-control"
                  name="pais"
                  [ngModel]="plato.pais"
                  placeholder="Especificar país..."
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <br />
          <div
            *ngFor="let ingrediente of plato.ingredientes; let i = index"
            class="row ingrediente"
          >
            <div class="col-md-2 col-sm-6 col-xs-12">
              <label>Ingrediente: </label>
            </div>
            <div class="col-md-10 col-sm-6 col-xs-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control form-contro-sm"
                  name="ingrediente_{{ i }}"
                  id="ingrediente_{{ i }}"
                  [ngModel]="ingrediente.ingrediente_description"
                  [ngbTypeahead]="searchIngredientes"
                  (blur)="onSearchTipoIngrediente(i)"
                  (keyup)="onSearchTipoIngrediente(i)"
                  placeholder="Especificar ingrediente..."
                />
              </div>
              <div
                class="text-danger error"
                *ngIf="
                  platoForm.value['ingrediente_' + i] &&
                  platoForm.value['ingrediente_' + i].includes(',')
                "
              >
                ¿Ha incluido más de un ingrediente? Para una correcta
                indexación, por favor, añada cada ingrediente de forma
                individual haciendo clic en "Añadir otro ingrediente".
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12">
              <label>Tipo: </label>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <select
                  class="form-control"
                  name="ingrediente_tipoID_{{ i }}"
                  id="ingrediente_tipoID_{{ i }}"
                  [ngModel]="ingrediente.tipo_id"
                >
                  <ng-container *ngFor="let tipo of tiposAlimento">
                    <ng-container *ngIf="ingrediente.tipo_id == tipo.tipo_id">
                      <option [value]="tipo.tipo_id" selected>
                        {{ tipo.tipo_description }}
                      </option>
                    </ng-container>
                    <ng-container *ngIf="ingrediente.tipo_id != tipo.tipo_id">
                      <option [value]="tipo.tipo_id">
                        {{ tipo.tipo_description }}
                      </option>
                    </ng-container>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-md-7 col-sm-8 col-xs-12 text-right">
              <span class="btn btn-light" (click)="onDeleteIngrediente(i)"
                ><i class="fa fa-trash-o"></i>
                &nbsp;&nbsp;Eliminar
              </span>
            </div>
          </div>
          <!--<div
            *ngFor="let ingrediente of plato.ingredientes; let i = index"
            class="row ingrediente"
          >
            <div class="col-md-2 col-sm-6 col-xs-12">
              <label>Ingrediente: </label>
            </div>
            <div class="col-md-7 col-sm-6 col-xs-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control form-contro-sm"
                  name="ingrediente_{{ i }}"
                  id="ingrediente_{{ i }}"
                  [ngModel]="ingrediente.ingrediente_description"
                  [ngbTypeahead]="searchIngredientes"
                  placeholder="Especificar ingrediente..."
                />
              </div>
            </div>
            <div class="col-md-2 col-sm-5 col-xs-6 pr-0">
              <div class="form-group">
                <select
                  class="form-control"
                  name="ingrediente_tipoID_{{ i }}"
                  id="ingrediente_tipoID_{{ i }}"
                  [ngModel]="ingrediente.tipo_id"
                >
                  <ng-container *ngFor="let tipo of tiposAlimento">
                    <ng-container *ngIf="ingrediente.tipo_id == tipo.tipo_id">
                      <option [value]="tipo.tipo_id" selected>
                        {{ tipo.tipo_description }}
                      </option>
                    </ng-container>
                    <ng-container *ngIf="ingrediente.tipo_id != tipo.tipo_id">
                      <option [value]="tipo.tipo_id" selected>
                        {{ tipo.tipo_description }}
                      </option>
                    </ng-container>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-md-1 col-sm-7 col-xs-6 text-right">
              <span class="btn btn-light" (click)="onDeleteIngrediente(i)"
                ><i class="fa fa-trash-o"></i>
              </span>
            </div>
          </div>-->

          <span
            class="btn btn-light btn-add"
            (click)="onAddIngrediente(platoForm)"
          >
            <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otro ingrediente
          </span>
        </div>

        <div class="col-md-12">
          <div
            *ngFor="let condimento of plato.condimentos; let i = index"
            class="row condimento"
          >
            <div class="col-md-2 col-sm-6 col-xs-12">
              <label>Condimento: </label>
            </div>
            <div class="col-md-10 col-sm-6 col-xs-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  name="condimento_{{ i }}"
                  id="condimento_{{ i }}"
                  [ngModel]="condimento.condimento_description"
                  [ngbTypeahead]="searchCondimentos"
                  (blur)="onSearchTipoCondimento(i)"
                  (keyup)="onSearchTipoCondimento(i)"
                  placeholder="Especificar condimento..."
                />
              </div>
              <div
                class="text-danger error"
                *ngIf="
                  platoForm.value['condimento_' + i] &&
                  platoForm.value['condimento_' + i].includes(',')
                "
              >
                ¿Ha incluido más de un condimento? Para una correcta indexación,
                por favor, añada cada condimento de forma individual haciendo
                clic en "Añadir otro condimento".
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12">
              <label>Tipo: </label>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="form-group">
                <select
                  class="form-control"
                  name="condimento_tipoID_{{ i }}"
                  id="condimento_tipoID_{{ i }}"
                  [ngModel]="condimento.tipo_id"
                >
                  <ng-container *ngFor="let tipo of tiposAlimento">
                    <ng-container *ngIf="condimento.tipo_id == tipo.tipo_id">
                      <option [value]="tipo.tipo_id" selected>
                        {{ tipo.tipo_description }}
                      </option>
                    </ng-container>
                    <ng-container *ngIf="condimento.tipo_id != tipo.tipo_id">
                      <option [value]="tipo.tipo_id">
                        {{ tipo.tipo_description }}
                      </option>
                    </ng-container>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="col-md-7 col-sm-8 col-xs-12 text-right">
              <span class="btn btn-light" (click)="onDeleteCondimento(i)"
                ><i class="fa fa-trash-o"></i>
                &nbsp;&nbsp;Eliminar
              </span>
            </div>
          </div>

          <span
            class="btn btn-light btn-add"
            (click)="onAddCondimento(platoForm)"
          >
            <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otro condimento
          </span>
        </div>

        <div class="col-md-12 text-right"></div>

        <div class="col-md-12 save">
          <button
            type="submit"
            class="btn btn-success"
            id="submitBtn"
            [disabled]="
              platoForm.invalid ||
              plato.estacion_id == '' ||
              !plato.tecnicas ||
              plato.tecnicas.length === 0 ||
              platoForm.value.horarioID == '' ||
              platoForm.value.dietaID == '' ||
              !plato.images ||
              plato.images.length === 0
            "
          >
            <i class="fa fa-floppy-o" aria-hidden="true"></i>&nbsp;&nbsp;Guardar
          </button>
          <p
            *ngIf="
              !platoForm.pristine &&
              (platoForm.invalid ||
                plato.estacion_id == '' ||
                !plato.tecnicas ||
                plato.tecnicas.length === 0 ||
                platoForm.value.horarioID == '' ||
                platoForm.value.dietaID == '' ||
                !plato.images ||
                plato.images.length === 0)
            "
            class="text-danger"
          >
            * Para guardar,<br />rellene todos los<br />campos obligatorios
          </p>
        </div>
      </div>
    </form>
  </div>
</div>
